<template>
  <div class="wrapper">
    <div class="main main-raised-zero">
      <div class="section text-center" v-if="loading">
        <h2 class="title">Loading...</h2>
      </div>
      <div class="section" v-if="recipe">
        <div class="container">
          <div class="team">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-75 md-small-size-100" style="margin: 0 auto;">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <h4 class="card-title">
                        {{ recipe.title }}
                        <br/>
                      <small class="card-description text-muted">
                        <stars :num="recipe.rating" />  {{ new Date(Date.parse(recipe.created)).toLocaleDateString() }}
                        <br/>
                        <time-2-make :mins="recipe.timeMins" /> -  
                        {{ recipe.style }} in the {{ recipe.season.join(', ').replace(/,([^,]*)$/, ' or' + '$1') }}
                      </small>
                    </h4>

                    <md-card-content>
                      <p class="card-description" v-if="recipe.description">{{ recipe.description }}</p>
                      <br v-if="recipe.description"/>
                      <span class="md-subheading">Ingredients</span>
                      <hr>
                      <recipe-ingredient
                        v-for="(ingredient, index) in recipe.ingredients"
                        :key="index+ingredient.amount"
                        :ingredient="ingredient"
                      />
                      <br/>
                      <span class="md-subheading">Directions</span>
                      <hr>
                      <p style="white-space: pre-wrap;">{{ recipe.instructions }}</p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeService from "@/services/RecipeService.js";
import RecipeIngredient from "@/views/RecipeIngredient.vue";
import Stars from "@/components/Stars.vue";
import Time2Make from "@/components/Time2Make.vue";

export default {
  bodyClass: "recipe-page",
  components: {
    RecipeIngredient,
    Stars,
    Time2Make
  },
  data() {
    return {
      loading: true,
      recipe: null,
      error: null
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.error = null;
      this.recipes = null;
      this.loading = true;

      RecipeService.recipe(this.$route.params.id)
        .then(recipe => {
          this.loading = false;
          this.recipe = recipe;
        })
        .catch(error => {
          this.loading = false;
          this.error = error;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.recipe-page {
  .page-header {
    &::before {
      background: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>


